import { Link } from '@tanstack/react-router';
import { CaretRight, House } from '@discovr/ui/design-system/icons';

interface BrandBreadcrumbProps {
  isHome: boolean;
  isStoreDiscounts: boolean;
  label: string;
  onHome: () => void;
}

export function BrandBreadcrumb({ isHome, isStoreDiscounts, label, onHome }: BrandBreadcrumbProps) {
  if (isStoreDiscounts) {
    return (
      <nav aria-label="Breadcrumb" className="text-body-sm-medium flex items-center gap-2">
        <Link to="/integrations" className="text-muted-foreground hover:text-foreground">
          Integrations
        </Link>
        <CaretRight size={14} className="text-muted-foreground/60" />
        <Link to="/integrations" className="text-muted-foreground hover:text-foreground">
          Shopify
        </Link>
        <CaretRight size={14} className="text-muted-foreground/60" />
        <span className="text-foreground" aria-current="page">
          Discounts
        </span>
      </nav>
    );
  }
  if (isHome) {
    return (
      <div className="text-body-sm-medium text-foreground flex items-center gap-1.5">
        <House size={16} /> Home
      </div>
    );
  }
  return (
    <div className="text-body-sm-medium flex items-center gap-2">
      <button
        type="button"
        onClick={onHome}
        className="text-muted-foreground hover:text-foreground flex items-center gap-1.5"
      >
        <House size={16} /> Home
      </button>
      <CaretRight size={14} className="text-muted-foreground/60" />
      <span className="text-foreground">{label}</span>
    </div>
  );
}
